import { Stack, Typography } from '@mui/material';
import { RadioInput } from 'Components/HookFormInputs/RadioInput';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary } from 'Hooks';
import { ITherapySuppliers } from 'Interfaces/therapySuppliers';
import { useFormContext } from 'react-hook-form';

const IsAccessible = () => {
  const { watch, setValue, resetField } = useFormContext<ITherapySuppliers>();

  const dictionary = useDictionary(
    Dictionary,
    DICTIONARY.Suppliers
  ).therapySearchForm;

  return (
    <Stack
      gap='20px'
      sx={{
        '.MuiSvgIcon-root > path': {
          strokeWidth: '0.833333',
          stroke: '#A020FF',
        },
      }}
      component='fieldset'
    >
      <legend>{dictionary.isAccessible}</legend>
      <Typography variant='body2'>{dictionary.isAccessible}</Typography>
      <RadioInput
        options={[
          { value: 1, label: dictionary.accessibleClinic },
          { value: 2, label: dictionary.homeTreatment },
          { value: 3, label: dictionary.noPreferences },
        ]}
        name={'accessible'}
        externalValue={watch('accessible') || ''}
        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
          switch (event.target.value) {
            case '1':
              if (watch('homeVisit') !== null) setValue('homeVisit', null);
              setTimeout(() => {
                setValue('accessible', true);
              }, 0);

              break;

            case '2':
              if (watch('homeVisit') !== null) setValue('homeVisit', null);
              setTimeout(() => {
                setValue('accessible', false);
              }, 0);
              break;

            case '3':
              setValue('homeVisit', true);
              setTimeout(() => {
                if (watch('accessible') !== null) setValue('accessible', null);
              }, 0);
              break;
          }
        }}
        replaceInternalOnChange={true}
      />
      {/* <RadioInput
        options={[{ value: true, label: dictionary.noPreferences }]}
        name={'homeVisit'}
        externalValue={watch('accessible') === null}
        onChange={() => {
          setValue('accessible', null);
        }}
      /> */}
    </Stack>
  );
};

export default IsAccessible;
